<template>
<header class="shadow-inner navbar-light light-blue lighten-4 fixed-top">
  <div class="top-header py-2 ">
    <div class="container custom-container">
    <div class="row">
      <div class="col-md-6 d-flex align-items-center">
        <div class="social-ic">
        <!-- Facebook -->
<i class="fs-16 mr-2 text-white fab fa-facebook-f"></i>

<!-- Twitter -->
<i class="fs-16 mr-2 text-white fab fa-twitter"></i>

<!-- Instagram -->
<i class="fs-16 mr-2 text-white fab fa-instagram"></i>

<!-- Linkedin -->
<i class="fs-16 mr-2 text-white fab fa-linkedin-in"></i>

<!-- Youtube -->
<i class="fs-16 mr-2 text-white fab fa-youtube"></i>

      </div>
      </div>
      <div class="col-md-6">
        <div class="d-flex gap-20 justify-content-end align-items-center header-side-margin">
          <a class="text-white fs-16" href="https://app.fixtrack.com/login-to-app">Login</a>
          <p class="mb-0 text-white">|</p>
          <a class="text-white fs-16" href="#" @click="confirmation" >Signup</a>
        </div>
      </div>
    </div>
  </div>
  </div>
<nav class="header-main navbar py-3  light-blue lighten-4">

  <!-- Navbar brand -->
  <a class=" nav-link px-0" :href="'/'">
  <img class="logo " :src="'/images/FixTrACk.png'" >
  </a>
  
        <div class="menu-toggle">
      <ul class="navbar-nav">
      <li class="nav-item fw-500 f-18 ">
        <a class="nav-link fw-bold" :href="'/'">Home <span class="sr-only">(current)</span></a>
      </li>   
      <li class="nav-item f-18 fw-500 has-submenu pr-md-0" @click="megamenuactive">
        <div class="has--submenu">
          <a class="nav-link has_menu_megamenu" :href="'javascript:0;'">Features<i class="fas fa-chevron-down ml-2 f-11"></i>
</a>
        </div>
        <megaMenu />
      </li>
      <!-- <li class="nav-item f-18 fw-500">
        <a class=" nav-link " :href="'/about_us'">About</a>
      </li> -->
      <li class="nav-item f-18 fw-500">
        <a class=" nav-link " :href="'/pricing'">Pricing</a>
      </li>
      <li class="nav-item f-18 fw-500">
        <a class=" nav-link " target="_blank" :href="'https://ifixyour.com/'">Ask an Expert </a>
      </li>
      <li class="nav-item f-18 fw-500">
        <a class=" nav-link " :href="'/demo'">Request a Demo</a>
      </li>
      <li class="nav-item f-18 fw-500">
        <a class=" nav-link " :href="'/book-repair'">Book a Repair</a>
      </li>
       
      <!-- <li class="nav-item btn-padding">
        <base-button :classButton="'bg-white btn-login-nav text-black font-weight-bold f-14'" :title="'login'" :buttonUrl="'https://app.fixtrack.com/login-to-app'"></base-button>
      </li>
      <li class="nav-item btn-padding">
        <base-button :classButton="'btn-bg-golden btn-free-trail text-black font-weight-bold f-14'" :title="'free trial'" :buttonUrl="'https://app.fixtrack.com/register-tenant'"></base-button>
      </li> -->
    </ul>
    </div>
    <!-- Collapse button -->
    <button class="navbar-toggler d-lg-none toggler-example" type="button" @click="toggleMenu">
      <span class="dark-blue-text">
        <i :class="menuIconClass"></i>
      </span>
    </button>
    <div :class="{ 'mobile__nav': true, 'menu__opened': isMenuOpen }">
      <mobileMenu />
    </div>
</nav>
<confirmModal ref="confirmModal"/>
</header>
</template>

<script>
import confirmModal from '../components/reusablecomponent/confirmModal.vue'
import BaseButton from '../components/UI/BaseButton.vue'
import megaMenu from './megaMenu.vue'
import mobileMenu from './mobileMenu.vue'

export default {
  components: {
    BaseButton,
    megaMenu,
    mobileMenu,
    confirmModal
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
   mounted(){
             var activeMenuItemIndex = localStorage.getItem('activeMenuItemIndex');
              if(activeMenuItemIndex !== null && activeMenuItemIndex !=0){
                              $('.nav-item:eq(0) a').removeClass('fw-bold');
                            }
                      console.log('');      
        if (activeMenuItemIndex !== null) {
            $('.nav-item:eq(' + activeMenuItemIndex + ') a').addClass('fw-bold');
        }
        $('.nav-item a').click(function(e) {
            $('.nav-item a').removeClass('fw-bold');
            $(this).addClass('fw-bold');
 
            var index = $(this).parent().index();
            
            localStorage.setItem('activeMenuItemIndex', index);
        });

         $('.has-submenu').click(function() {
            localStorage.setItem('activeMenuItemIndex', 1);
        });
          
   },
  computed: {
    menuIconClass() {
      return this.isMenuOpen ? 'fas fa-times fa-1x' : 'fas fa-bars fa-1x';
    },
  },
  methods: {
    confirmation(){
      this.$refs.confirmModal.openModal();
    },
    toggleMenu(event) {
  this.isMenuOpen = !this.isMenuOpen;
  // Switch the classes of the button icon
  event.target.classList.toggle('menu-opened');
  const iconElement = document.querySelector('.navbar-toggler i');
  if (iconElement) {
    iconElement.classList.toggle('fa-bars', !this.isMenuOpen);
    iconElement.classList.toggle('fa-times', this.isMenuOpen);
  }
},
    megamenuactive() {
      const megamenubtn = document.querySelector('.nav-item.has-submenu');
      const megamenu = document.querySelector('.nav-item.has-submenu .megamenu_wrapper');
      megamenubtn.classList.toggle('active-megamenu');

      if (megamenubtn.classList.contains('active-megamenu')) {
        megamenu.style.maxHeight = megamenu.scrollHeight + 10 + 'px';
      } else {
        megamenu.style.maxHeight = 0;
      }
    },
  },
};
</script>
